import React from 'react';
import { Stack } from '../../Stack';
import { FieldWrapper } from '../FieldWrapper';
import { Radio, RadioGroup, RadioSize } from '../FormItems';

type FieldWrapperProps = React.ComponentProps<typeof FieldWrapper>;
type StackProps = React.ComponentProps<typeof Stack>;

type RadioOption = {
  /** ラジオボタンの値 */
  value: string;
  /** ラベルテキスト */
  label: string;
  /** 説明テキスト */
  description?: string;
  /** 無効状態 */
  disabled?: boolean;
};

type RadioGroupProps = {
  /** ラジオボタンのサイズ */
  size?: RadioSize;
  /** 選択肢の配列 */
  options: RadioOption[];
  /** 現在の選択値 */
  value?: string;
  /** 値が変更されたときのコールバック */
  onValueChange: (value: string) => void;
  /** 無効状態 */
  disabled?: boolean;
  /** ラジオボタンの配置方向 */
  direction?: StackProps['direction'];
  /** ラジオボタン間のgap */
  gap?: StackProps['gap'];
};

type Props = {
  radioGroup: RadioGroupProps;
  fieldWrapperProps: Omit<FieldWrapperProps, 'children'>;
};

const DEFAULT_DIRECTION = 'column';
const DEFAULT_GAP = 12;

export const RadioField: React.FC<Props> = ({
  radioGroup: {
    size = 'regular',
    options,
    value,
    onValueChange,
    disabled,
    direction = DEFAULT_DIRECTION,
    gap = DEFAULT_GAP,
  },
  fieldWrapperProps: { htmlFor, labelType, labelText, beforeMessage, errorMessages },
}) => (
  <FieldWrapper
    htmlFor={htmlFor}
    labelType={labelType}
    labelText={labelText}
    beforeMessage={beforeMessage}
    errorMessages={errorMessages}
  >
    <RadioGroup value={value} onValueChange={onValueChange} disabled={disabled}>
      <Stack direction={direction} gap={gap}>
        {options.map(option => (
          <Radio
            key={option.value}
            value={option.value}
            size={size}
            label={option.label}
            description={option.description}
            disabled={option.disabled}
          />
        ))}
      </Stack>
    </RadioGroup>
  </FieldWrapper>
);
